import { useMemo, useRef, useState } from "react";
const useLoading = () => {
  const [loading, setLoading] = useState(false);
  const toggleCount = useRef(0);
  const loaded = useMemo(() => {
    if (loading === true || loading === false && toggleCount.current > 0) {
      toggleCount.current = toggleCount.current + 1;
    }
    if (toggleCount.current > 1) {
      return true;
    }
    return false;
  }, [loading]);
  const runTask = (task) => {
    setLoading(true);
    return task.finally(() => {
      setLoading(false);
    });
  };
  return {
    loading,
    loaded,
    setLoading,
    runTask
  };
};
var useLoading_default = useLoading;
export {
  useLoading_default as default
};
